<template>
	<!-- 招聘 -->
	<div class="kr-layout-content">
		<div class="content-left">
			<!--职位信息-->
			<div class="new-article">
				<!--招聘列表-->
				<ul class="art-list">
					<li v-for="item in lists" :key="item.id" @click="toDetail(item.id,item.type)">
						<div class="head-img">
							<img :src="item.pic" alt />
						</div>
						<div class="content">
							<div class="title">
								<p class="twoline">{{item.title}}</p>
							</div>
							<p class="intro oneline">{{item.subTitle}}</p>
							<div class="author">
								<div class="author-img">
									<img :src="item.userHeadPic" alt />
								</div>
								<p class="name">
									{{item.userName }}
									<span>.</span>
									{{item.createTime}}
								</p>
							</div>
						</div>
					</li>
				</ul>
				<div v-if="loadmore" class="look-more" @click="getDate">查看更多</div>
				<p v-if="!loadmore" class="none-more">没有更多了</p>
			</div>
		</div>
	</div>
</template>
<script>
	import eventBus from '@/common/eventBus'
	let timer = null;
	export default {
		//   name: "App",
		data() {
			return {
				keyWord: null,
				lists: [],
				loadmore: true,
				curPage: 1
			};
		},
		methods: {
			toDetail(id, type) {
				if (type == 2) {
					this.$router.push({
						path: "/vdDetails",
						query: {
							id: id,
							type: type
						}
					});
				} else {
					this.$router.push({
						path: "/ghDetails",
						query: {
							id: id,
							type: type
						}
					});
				}
			},
			getData() {
				this.$http
					.get(
						"/api/core/002--newsList?title=" +
						this.keyWord +
						"&pageNo=" +
						this.curPage
					)
					.then(res => {
						if (res.status == 200 && res.data.code == 0) {
							this.lists.push(...res.data.rows);
							if (this.curPage >= res.data.totalPage) {
								this.loadmore = false;
							}
							this.curPage++;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			getDate() {
				this.getData()
			},
		},
		newsMore() {
			//查看更多
			this.getData();
		},
		created() {
			console.log(this.$route.query.keyWord);
			this.keyWord = this.$route.query.keyWord;
			if (this.$route.query.goStatus == 1) {
				var that = this
				setTimeout(function() {
					that.$store.commit("userPerson", {
						a: true
					});
				}, 500)
			}
			this.getData();
		},
		mounted() {
			eventBus.$on('updateSearchData',res => {
				this.keyWord = res;
				this.curPage = 1;
				this.lists = [];
				this.getData();
			})
		},
		beforeUnmount() {
			eventBus.$off('updateSearchData')
		}
	};
</script>
<style scoped>
	.content-left {
		width: 100%;
		padding: 30px 10px 60px 20px;
	}

	.content-left .post-details {
		width: 100%;
	}
	.author-img {
		margin-right: 10px;
	}
</style>
